import React, { Component } from "react";
import styles from "./winterUnits.module.scss";
import { withWinter } from "../../../shared/containers/containerWinter";

class WinterUnitsToolMode extends Component {
  render() {
    const { selectedWinterGroup, winterUnits } = this.props;

    const title =
      selectedWinterGroup === null
        ? `Режим редактирования списка ТС зимнего содержаниея`
        : `Режим редактирования списк ТС группы "${selectedWinterGroup.title}"`;

    let count = winterUnits.length;

    if (selectedWinterGroup !== null) {
      count = 0;

      winterUnits.forEach((unit) => {
        if (
          unit.groups.some((x) => {
            return x.id === selectedWinterGroup.id;
          })
        ) {
          count++;
        }
      });
    }

    return (
      <div className={styles.winterUnitsToolModeContainer}>
        <div> {title}</div>
        <div>Количество ТС: {count}</div>
      </div>
    );
  }
}

export default withWinter(React.memo(WinterUnitsToolMode));
